import { getStaticPath } from '@/util/request'

const parseUrl = url => (/^@/.test(url)) ? url.replace(/^@/,'/public/') : url

export default {
  name: 'A',
  props: {
   href:{
    type:String,
    default:''
   },
   name:{
    type:String,
    default:''
   },
  },
  
  created() {
    
  },
  methods:{
    handleClick(){
      let url = parseUrl(this.href) + '?'+Date.now()
      if(url){
        this.$request.blob( url ).then(resp=>{
  
          let { data , headers} = resp
          if( data ){
            let filename = this.name || url.split('/').pop();
            if( headers['content-disposition'] ){
              filename = headers['content-disposition'].split('filename=')[1].replace(/"/g,'')
            }
            this.$utils.saveFile( data , filename)
          }else{
            this.$Message.error('无法获取内容')
          }
        })
      }
    }
  },

  render(){
    const node = this.$scopedSlots.default ? this.$scopedSlots.default() : null
    return <a on-click={this.handleClick}>{node}</a>
  }
}
